import { Observable, Subject } from 'rxjs';

export type ValidStateChangeEvent = { readonly valid: boolean };

export const InvalidStateEvent: ValidStateChangeEvent = { valid: false };
export const ValidStateEvent: ValidStateChangeEvent = { valid: true };

export class ValidStateEmitter {
  private _validateStateChangeSubject = new Subject<ValidStateChangeEvent>();
  private _validStateChange$ = this._validateStateChangeSubject.asObservable();

  get validStateChange$(): Observable<ValidStateChangeEvent> {
    return this._validStateChange$;
  }

  fireValidStateChange(event: ValidStateChangeEvent): void {
    this._validateStateChangeSubject.next(event);
  }
}
